module.exports = __webpack_public_path__ + "img/arrow-right-up.5bb7115b.svg";